module.exports = {"id":"216460","name":"José María Giménez","rating":"83","photo":"./data/images/photos/3/216460.png","club":{"name":"Atlético Madrid","logo":"./data/images/clubs/AtleticoMadrid.png"},"positions":["DC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JoseMariaGimenez0.json
// module id = 2177
// module chunks = 0